import { type ComponentPropsWithoutRef, type FC } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import { articleBodyClass, articleImageContainerClass, articleImageHeadingContainerClass } from './Article.css';

export const ArticleImageContainer: FC<ComponentPropsWithoutRef<'div'>> = ({ className, ...props }) => (
  <div className={getClassNames(articleImageContainerClass, className)} {...props} />
);

export const ArticleImageHeadingContainer: FC<ComponentPropsWithoutRef<'div'>> = ({ className, ...props }) => (
  <div className={getClassNames(articleImageHeadingContainerClass, className)} {...props} />
);

export const globalStyles = () => {
  if (typeof document !== 'undefined') {
    document.body.classList.add(articleBodyClass);
  }
};

export const clearGlobalStyles = () => {
  if (typeof document !== 'undefined') {
    document.body.classList.remove(articleBodyClass);
  }
};
